import React from 'react';

interface Props {
  children: React.ReactElement;
}

export class Container extends React.Component<Props> {
  render () {
    const { children } = this.props;
    return <div className="container">{children}</div>;
  }
}
